import {Entity, IEntity} from '../../../wappy/domain/entity';
import {IPolicyKey, PolicyKey} from './policy-key';

export interface IPolicy extends IEntity {
    key: IPolicyKey;
    version: string;
    content: string;
    langCode?: string;
}

export class Policy extends Entity implements IPolicy {
    readonly key: PolicyKey;
    readonly version: string;
    readonly content: string;
    readonly langCode?: string;

    constructor(data: IPolicy) {
        super(data);
        this.key = data.key instanceof PolicyKey ? data.key : new PolicyKey(data.key);
        this.version = data.version;
        this.content = data.content;
        this.langCode = data.langCode;
    }

    get versionNumber(): number {
        return parseFloat(this.version) || 0;
    }

    get languageLabelKey(): string {
        return this.langCode ? `language.${this.langCode}` : '';
    }

    contentPreview(maxChars = 110): string {
        const stripped = (this.content ?? '').replace(/<[^>]+>/g, '').trim();
        return stripped.length > maxChars ? stripped.slice(0, maxChars) + '…' : stripped;
    }
}

export interface IPublishPolicyTranslation {
    langCode: string;
    text: string;
}

export interface IPublishPolicyResult {
    version: string;
    policies: IPolicy[];
}
